import React from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'

export default function NewsItem({ value}) {
  const { mainImage, title, published } = value
  const imgUrl = mainImage || "/img/custom/hand.png";
  const to = `/novice/${kebabCase(title)}`;
  return (<div className="box">
    <Link to={to} className="imgLink">
      <img src={imgUrl} alt={title} />
    </Link>
    <div>
      <h3>
        <Link to={to}>{title}</Link>
      </h3>
      <span className="date">{published}</span>
    </div>
  </div>);
}
